// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"counters-module___scrollWrapper___cb0a804d","counters":"counters-module___counters___e2fe851f","separator":"counters-module___separator___a2ec7252"};